// libraries
import { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import firebase from "../firebase/firebase";

// context
import UserContext from "../context/user";

// components
import Hero from "../components/Hero";
import UserLoading from "../components/Loading";
import RecommendedRecipesItem from "../components/Home/RecommendedRecipesItem";
import Newsletter from "../components/Newsletter";

// firestore
const favoritesDocument = firebase.firestore().collection("users");

const Favorites = () => {
  // use context
  const { user } = useContext(UserContext);

  // use states
  const [loading, setLoading] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [favState, setFavState] = useState();

  // use toast
  const { addToast } = useToasts();

  useEffect(() => {
    if (user) {
      var arr = [];
      setLoading(true);
      favoritesDocument
        .doc(user.uid)
        .collection("favorites")
        .onSnapshot((snapshot) => {
          arr = snapshot.docs.map((doc) => doc.data());
          setLoading(false);
          setFavorites(arr);
        });
    }
  }, [user]);

  if (!user) {
    addToast("Please login first!", {
      appearance: "error",
    });
    return <Redirect to='/' />;
  }

  return (
    <div>
      <Hero
        image='https://s.abcnews.com/images/US/rocco-dispirito-recipes-01-skillet-cookie-ht-jc-200305_hpMain_16x9_1600.jpg'
        title='My Favorites'
        breadName='Favorites'
        singleProduct={false}
      />
      {loading ? (
        <div className='loading-wrapper'>
          <UserLoading />
        </div>
      ) : (
        <div className='ftco-section'>
          <div className='container'>
            <div className='row'>
              {favorites.length > 0 ? (
                favorites.map((item, index) => {
                  return (
                    <RecommendedRecipesItem
                      key={index}
                      title={item.title}
                      id={item.id}
                      meal={item.meal}
                      category={item.category}
                      image={item.image}
                      user={item.user}
                    />
                  );
                })
              ) : (
                <div className='recipes-empty'>
                  <h5>No recipes to show!</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Newsletter />
    </div>
  );
};

export default Favorites;
